// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import axios from "./http";
import { Message } from '@/utils/plugins.js';

// get request
function getRequest(url, params = {}, config = {}) {
    let temUrl = '', temConfig = { ...config }, temCatchCallBack = null;
    if(temConfig.catchCallBack) {
        temCatchCallBack = temConfig.catchCallBack;
        delete temConfig.catchCallBack;
    } else {
        temCatchCallBack = () => {};
    }
    for (const key in params) {
        if (params[key] || params[key] === 0 || config.couldNull) {
            temUrl = temUrl + key + '=' + params[key] + '&';
        }
    }
    temConfig.headers = temConfig.headers || {
        withCredentials : true,
        "Cache-Control" : "no-cache"
    }
    temConfig[""] = true;
    if(temUrl) {
        temUrl = '?' + temUrl.slice(0, -1);
    }
    return axios.get(url + temUrl, temConfig);
}

const downloadLockObj = {};
/**
 * 下载文件
 * @param {String} url Download link
 * @param {*} params Download parameters
 * @param {*} config Download configuration information, fileName:  Download file name
 * @returns Return Promise Asynchronous
 */
function getUploadRequest(url, params = {}, config = {}) {
    let temUrl = '', downloadLockStr = null; //DownloadLock: After downloading once, if it has not been downloaded completely, it cannot be downloaded again
    for (const key in params) {
        if (params[key] || params[key] === 0) {
            temUrl = temUrl + key + '=' + params[key] + '&';
        }
    }
    if(temUrl) {
        temUrl = '?' + temUrl.slice(0, -1);
    }
    if(!!!temUrl)
    {
        temUrl = "?" + "language=" + window.userLanguage;
    }
    else
    {
        temUrl = "&language=" + window.userLanguage;
    }
    downloadLockStr = url + temUrl;
    
    if(downloadLockObj[downloadLockStr]) {
        Message.info('Downloading');
        return Promise.resolve();
    } else {
        downloadLockObj[downloadLockStr] = true;
    }

     // Message.info('Start Download');
      Message.info('Downloading');
    return axios.get(url + temUrl, { specialType: 'download', 'content-type': 'application/octet-stream', responseType: 'blob', Connection: 'keep-active' }).then(res => {
        if(res && res.code === 200) {
            // 从响应头中获取 MIME 类型
            const contentType = res.data.type;
            // 定义允许的 MIME 类型白名单
            const allowedMimeTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',   
            "application/json"
            // 添加其他你需要的合法类型
            ];

            // 验证 MIME 类型
            if (!allowedMimeTypes.includes(contentType)) {
                //this.message = '不允许下载此类型的文件';
                return;
            }
            const url = window.URL.createObjectURL(res.data);

            // Create an A tag for downloading
            const link = document.createElement('a');
            link.href = url;
            try
            {
                link.setAttribute('download', config.fileName || 'Default'); // You can set the file name you want
            }
            catch(e){}
            

            // Trigger download
            //document.body.appendChild(link);
            link.click();

            // Then remove the label a
            //document.body.removeChild(link);
        
        }
        return res;
    }).finally(() => delete downloadLockObj[downloadLockStr]);
}

// Post type request
function postRequest(url, params = {}, config = {}) {
    let data = {}, temConfig = { ...config }, temCatchCallBack = null;
    if(temConfig.catchCallBack) {
        temCatchCallBack = temConfig.catchCallBack;
        delete temConfig.catchCallBack;
    } else {
        temCatchCallBack = () => {};
    }
    for (const key in params) {
        if ((params[key] || params[key] === 0) && !config.allowNull) {
            data[key] = params[key];
        } else {
            data[key] = params[key];
        }
    }
    if(typeof params === 'string'){
        return axios.post(url+'?id=' + params);
    }
    temConfig.headers = temConfig.headers || {
        withCredentials : true,
        "Cache-Control" : "no-cache"
    }
    return axios.post(url, data, temConfig);
}

function postUploadRequest(url, params = {}, config = { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 5 * 60000 }) {
    const formData = new FormData();
    for (const key in params) {
        if (params[key] || params[key] === 0) {
            formData.append(key, params[key]);
        }
    }
    return axios.post(url, params, config);
}

// Put type request
function putRequest(url, params = {}, config = {}) {
    let data = {}, temConfig = { ...config }, temCatchCallBack = null;
    if(temConfig.catchCallBack) {
        temCatchCallBack = temConfig.catchCallBack;
        delete temConfig.catchCallBack;
    } else {
        temCatchCallBack = () => {};
    }
    for (const key in params) {
        if ((params[key] || params[key] === 0) && !config.allowNull) {
            data[key] = params[key];
        } else {
            data[key] = params[key];
        }
    }
    return axios.put(url, data, temConfig);
}

// Delete class request
/**
 * 
 * @param {*} url 
 * @param {*} idArray The array is Id, and the string is ids
 * @param {*} catchCallBack 
 * @returns 
 */
function deleteRequest(url, idArray, config = {}) {
    let temConfig = { ...config }, temCatchCallBack = null;
    if(temConfig.catchCallBack) {
        temCatchCallBack = temConfig.catchCallBack;
        delete temConfig.catchCallBack;
    } else {
        temCatchCallBack = () => {};
    }
    if(typeof idArray !== 'string') {
        url = url + '?id=' + idArray.join(',');
    } else {
        url = url + '?ids=' + idArray;
    }
    return axios.delete(url, temConfig);
}

function deleteObjRequest(url, idObj = {}, config = {}) {
    let temUrl = '', temConfig = { ...config }, temCatchCallBack = null;
    if(temConfig.catchCallBack) {
        temCatchCallBack = temConfig.catchCallBack;
        delete temConfig.catchCallBack;
    } else {
        temCatchCallBack = () => {};
    }
    for (const key in idObj) {
        if (idObj[key] || idObj[key] === 0 || config.couldNull) {
            temUrl = temUrl + key + '=' + idObj[key] + '&';
        }
    }
    if(temUrl) {
        temUrl = '?' + temUrl.slice(0, -1);
    }
    return axios.delete(url + temUrl, temConfig);
}

export { getRequest, postRequest, putRequest, deleteRequest, getUploadRequest, postUploadRequest, deleteObjRequest }